module.exports = __webpack_public_path__ + "static/media/petra-obojes.48bf2459.jpg";